import { loadMoreInTable } from 'owa-mail-list-actions';
import { initTableSelectionOnLoad } from 'owa-mail-actions';
import {
    getSelectedTableView,
    LoadErrorStatus,
    TableView,
    TableQueryType,
} from 'owa-mail-list-store';
import { lazyPrefetchFirstN } from 'owa-mail-prefetch';
import { getCanTableLoadMore } from 'owa-mail-table-loading-actions';
import { action } from 'satcheljs/lib/legacy';

const FIRST_N_ROW_PREFETCH_COUNT = 10;

/**
 * Try load more upon the initial load rows completed
 * @param tableView the table to load more
 */
const tryLoadMoreUponInitialLoadCompleted = action('tryLoadMoreUponInitialLoadCompleted')(
    function tryLoadMoreUponInitialLoadCompleted(tableView: TableView) {
        // Try to load more if necessary
        if (getCanTableLoadMore(tableView)) {
            setTimeout(function() {
                // Loading of more rows should be done asynchronously
                // We must check getCanTableLoadMore again after setTimeout
                if (getCanTableLoadMore(tableView)) {
                    loadMoreInTable(tableView);
                }
            }, 100);
        }
    }
);

/**
 * Callback for table load complete
 * @param tableView the table view
 * @param isSuccessResponseClass indicates if the response is success
 * @param isTablePrefetched indicates if the table is prefetched
 */
export default action('onInitialTableLoadComplete')(function onInitialTableLoadComplete(
    tableView: TableView,
    isSuccessResponseClass: boolean,
    responseCode: string,
    isTablePrefetched: boolean
) {
    // Set loading state to complete
    tableView.isLoading = false;
    tableView.isInitialLoadComplete = true;

    if (isTablePrefetched) {
        return;
    }

    // If the response class is success then prefetch and perform auto selection
    if (isSuccessResponseClass) {
        tableView.loadErrorStatus = LoadErrorStatus.None;
        const hasSelection = tableView.selectedRowKeys.size > 0;

        // do auto selection and prefetch first N rows for Folder and Group tables
        if (
            tableView.tableQuery.type == TableQueryType.Folder ||
            tableView.tableQuery.type == TableQueryType.Group
        ) {
            // Init table selection if selected table doesn't already have any selected rows
            if (!hasSelection && tableView == getSelectedTableView()) {
                initTableSelectionOnLoad(tableView);
            }

            lazyPrefetchFirstN.importAndExecute(tableView, FIRST_N_ROW_PREFETCH_COUNT);
        }

        // Backfill more rows in the table
        tryLoadMoreUponInitialLoadCompleted(tableView);
    } else {
        switch (responseCode) {
            case 'ErrorAccessDenied':
                tableView.loadErrorStatus = LoadErrorStatus.AccessDenied;
                break;
            default:
                tableView.loadErrorStatus = LoadErrorStatus.Other;
        }
    }
});
